<template>
  <div class="ui-editor-content" v-html="markup">

  </div>
</template>

<script>
import edjsParser from "./parser/Parser";
import "./index.scss"

const parser = new edjsParser();

export default {
  name: "UiJsonToHtml",
  props: {
    json: {
      required: true,
    }
  },
  computed: {
    markup() {
      return parser.parse(this.json)
    }
  }
}
</script>

<style>

</style>